import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { ServiceRecord } from '../entities/records';
import * as selectors from '../entities/Service/selectors';

function mapStateToProps(state, { serviceId }) {
  return {
    service: selectors.serviceById(state, serviceId),
  };
}

export default compose(
  setPropTypes({
    serviceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    service: PropTypes.instanceOf(ServiceRecord),
  }),
)(mapStateToProps);
